export function calcArea(vertices: [number, number][], scale: number) {
    let total = 0;
    const pixelSize = ((dpi / 2.54) * 100) / scale;
    for (let i = 0, l = vertices.length; i < l; i++) {
        let addX = vertices[i][0];
        let addY = vertices[i == vertices.length - 1 ? 0 : i + 1][1];
        let subX = vertices[i == vertices.length - 1 ? 0 : i + 1][0];
        let subY = vertices[i][1];
        
        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
    }

    const res = Math.abs(total/Math.pow(pixelSize, 2)).toFixed(2);
    return parseFloat(res);
}

export const dpi: number = 200;

export const paramsSeparator: string = '|';

export const polygonColors = {
    green: '#10f414',
    blue: '#0207d7',
    yellow: '#fcfa24'
};

export function sanitizeTextInput(value: string, maxLength: number = 256): string {
    if (value === undefined || value === null) {
        return '';
    }

    const normalized = String(value)
        .replace(/[\u0000-\u001F\u007F]/g, '')
        .replace(/[<>`"'\\]/g, '')
        .trim();

    return normalized.substring(0, maxLength);
}

export function sanitizeTokenInput(value: string): string {
    if (value === undefined || value === null) {
        return undefined;
    }

    const normalized = String(value).trim();
    return /^[A-Za-z0-9\-._~+/=]+$/.test(normalized) ? normalized : undefined;
}

export function sanitizeCodEnte(value: string): string {
    const normalized = sanitizeTextInput(value, 64);
    return /^[A-Za-z0-9_-]{1,64}$/.test(normalized) ? normalized : undefined;
}

export function sanitizeFilenameStem(value: string): string {
    const normalized = sanitizeTextInput(value, 120).replace(/\.(json|png)$/i, '');
    if (!normalized || normalized.indexOf('..') !== -1 || normalized.indexOf('/') !== -1 || normalized.indexOf('\\') !== -1) {
        return undefined;
    }

    return /^[A-Za-z0-9._-]{1,120}$/.test(normalized) ? normalized : undefined;
}

export function sanitizePipeSeparatedInput(value: string, expectedParts: number): string[] {
    if (!value) {
        return [];
    }

    const parts = value.split(paramsSeparator).map((part) => sanitizeTextInput(part, 64));
    if (parts.length !== expectedParts || parts.some((part) => !/^[A-Za-z0-9._-]*$/.test(part))) {
        return [];
    }

    return parts;
}